import { forwardRef } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import {
  TABS_DEFAULTS,
  TABS_VARIANT_CLASS_MAP,
  type TTabsTriggerElement,
  type TTabsTriggerProps,
} from "@/ui/components/navigation/Tabs/Tabs.config";
import { cn } from "@/ui/lib/utils";
import { TextControl } from "../../typography/TextControl";
import { TextBody } from "../../typography/TextBody";

export const TabsTrigger = forwardRef<TTabsTriggerElement, TTabsTriggerProps>(
  (
    {
      className,
      variant = TABS_DEFAULTS.variant,
      description,
      children,
      ...props
    },
    ref,
  ) => (
    <TabsPrimitive.Trigger
      data-component="TabsTrigger"
      ref={ref}
      className={cn(
        "px-2 py-1 flex justify-center items-center flex-col space-y-1",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary",
        TABS_VARIANT_CLASS_MAP[variant].trigger,
        className,
      )}
      {...props}
    >
      <TextControl tag="span" size={2} isResponsive={false} color="inherit" align="center">{ children }</TextControl>
      { description ? (
        <TextBody tag="span" size={3} isResponsive={false} color="inherit" align="center">{ description }</TextBody>
      ): null }
    </TabsPrimitive.Trigger>
  ),
);

TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
